// extracted by mini-css-extract-plugin
export default {"popover":"popover-3qJywW","popover-slide":"popover-slide-1R3pe7"};